import { useEffect } from 'react';
import * as React from 'react';
import Dinero from 'dinero.js';
import { GetAppData } from '../_actions/AppDataActions';
import { useAppDispatch } from '../../Common/_hooks/useAppDispatch';
import { useAppSelector } from '../../Common/_hooks/useAppSelector';

export type Props = React.PropsWithChildren<{
	loaderComponent?: React.ReactNode
}>

export default function ApplicationDataLayer(props:Props) {
	const dispatch = useAppDispatch();

	const loading = useAppSelector(state => state.get('UIData').get('loaders').get('appData'));
	const currency = useAppSelector(state => state.get('userData').get('prefs').get('currency'));
	const ready = useAppSelector(state => {
		const appData = state.get('appData');
		const firstProduct = appData.get('products').first();
		const appDataCurrency = firstProduct?.get('price_retail').get('currency');

		return appData.get('countries').count() > 0
			&& appData.get('products').count() > 0
			&& appData.get('productCategories').count() > 0
			&& appData.get('productSubCategories').count() > 0
			&& appDataCurrency === currency;
	});

	useEffect(() => {
		if(loading || ready) return;

		dispatch(GetAppData())
		setCurrency();
	}, [dispatch, loading, ready]);

	useEffect(() => {
		setCurrency();
	}, [currency]);

	const setCurrency = () => Dinero.globalLocale = currency == 'USD' ? 'en-US' : window.LOCALE.replace('_','-');

	if(loading || !ready) {
		return props.loaderComponent ? props.loaderComponent : <></>
	}
	
	return props.children
}
